<template>
  <!-- 盒子/饰品升级-添加盒子-盒子列表弹窗 -->
  <div>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="选择物品" width="900px"
      @close="closeDialog">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="query.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getData(1)">确定</el-button>
        </el-form-item>
      </el-form>

      <div class="body-box" v-loading="loading">
        <ul class="goods-ul">
          <li class="goods-li" v-for="item in dataList" :key="item.id">
            <div class="goods-li-bg">
              <span class="add-icon">
                <i class="el-icon-circle-plus" title="添加" @click="handleAddPrize(item)"></i>
              </span>
              <div class="goods-img">
                <img :src="item.image" alt="">
              </div>
              <p class="goods-name">{{item.name}}</p>
              <p class="goods-price">{{item.price}}<img class="diamond" style="vertical-align:middle;width:16px;"
                  src="@/assets/img/diamond-icon.png" /></p>
            </div>
          </li>
        </ul>
        <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0"
          :current-page="dataMeta.current_page" @current-change="handlePageChange"
          v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '@/http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    typeDialog: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visibleDialog: false,//盒子弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      query: {
        page: 1,
        name: '',
        category_id: 6,//代表查询盒子分类中的：升级盒子
      },
      dataList: undefined,//数据列表
      dataMeta: undefined,//底部分页数据
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
    dialogType: {
      get() {
        return this.typeDialog
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getData()
      }
    },
  },
  created() {
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('box', params).then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res.meta
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleAddPrize(row) {
      this.$emit("refresh", row)//返回选择数据
      this.closeDialog()//关闭弹窗
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
.body-box {
  width: 100%;

  .goods-ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .goods-li {
      width: 20%;
      padding: 0px 10px;
      margin-bottom: 10px;
      box-sizing: border-box;

      .goods-li-bg {
        padding: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: 1px solid rgb(207, 206, 206);
        border-radius: 4px;
        position: relative;

        .add-icon {
          cursor: pointer;
          position: absolute;
          right: 5px;
          top: 5px;
          font-size: 25px;
          color: rgb(64, 158, 255);

          &:hover {
            color: rgb(23, 136, 250);
          }
        }

        .goods-img {
          width: 80%;
          height: 100px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 100%;
          }
        }

        .goods-name {
          width: 100%;
          margin: 10px 0px;
          font-size: 14px;
          text-align: center;
        }

        .goods-price {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>